import {
  OpenAPIObject,
  OperationObject,
  PathItemObject,
  SchemaObject,
} from 'openapi3-ts';

export const getFormattedExample = (
  examples: SchemaObject['examples'],
  exampleIndex: number = 0,
): string => {
  const exampleValues = Object.values(examples);
  if (exampleValues.length === 0) {
    return '';
  }
  if (exampleIndex >= exampleValues.length) {
    // eslint-disable-next-line no-console
    console.warn(`Schema: index ${exampleIndex} is out of range.`);
    exampleIndex = 0;
  }

  const targetExample = exampleValues[exampleIndex];
  if (
    !!targetExample &&
    Object.keys(targetExample).length === 1 &&
    !!targetExample?.value
  ) {
    return JSON.stringify(targetExample.value, null, 2); // format JSON with 2 space indentation
  }

  return JSON.stringify(targetExample, null, 2); // format JSON with 2 space indentation
};

export const getRouteFromDefinition = (
  definition: OpenAPIObject,
  route: string,
  method: string,
): OperationObject | undefined => {
  const routeFromDefinition =
    definition.paths[route]?.[(method ?? 'POST').toLowerCase()];
  if (routeFromDefinition == null) {
    // eslint-disable-next-line no-console
    console.warn(`Schema: route ${route} not found in API definition.`);
    return null;
  }

  // console.log('routeFromDefinition', routeFromDefinition);
  return routeFromDefinition;
};

// Schema names seed the DOM ids of every field row, and those ids are public
// deep-link targets. GET and POST are omitted so existing anchors keep working;
// other methods are qualified so that two operations documented on the same
// path (for example PUT and GET on a revocation route) don't collide.
export const getSchemaNamePrefix = (route: string, method: string): string => {
  const routeKebabCase = route
    .replace(/^\//, '')
    .split('/')
    .join('-')
    .toLowerCase();
  const upperMethod = (method ?? 'POST').toUpperCase();
  return upperMethod === 'GET' || upperMethod === 'POST'
    ? routeKebabCase
    : `${routeKebabCase}-${upperMethod.toLowerCase()}`;
};

export const getContentProperty = (
  content: any,
  property: 'schema' | 'examples',
) => {
  // console.log('content', content);
  return (
    content?.['application/json']?.[property] ||
    content?.['application/x-www-form-urlencoded']?.[property]
  );
};
